<template>
    <li class="nav-item"
        v-if="this.f_modalita_fiera || this.f_distretto">
        <a href="#" class="nav-link" @click.prevent="onRoomClick()">
            <i class="fa fa-map-marker-alt"></i>
            <b class="d-none d-md-inline-block">
                {{this.locale.nome_locale}}
                <span v-if="this.service_point">- {{this.service_point.traduzione.nome}}</span>
            </b>
        </a>
    </li>
    <li v-else class="nav-item dropdown">
        <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button"
           aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-map-marker-alt"></i>&nbsp;&nbsp;
            <b class="d-none d-md-inline-block mr-2">
                {{this.locale.nome_locale}}
            </b>
        </a>
        <div class="dropdown-menu">
            <a class="dropdown-item" href="#" v-for="locale in this.locali" @click.prevent="onRoomClick(locale)">
                {{locale.nome_locale}}
            </a>
        </div>
    </li>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "IncDropdownRooms",
    computed: {
        service_point: function () {
            if (this.f_modalita_fiera) {
                return this.punti_di_servizio.find((point) => {
                    return point.id === this.id_punto_di_servizio
                });
            }

            return null;
        },
        ...mapState('restaurant', {
            locali: state => state.locali,
            locale: state => state.locale,
            punti_di_servizio: state => state.punti_di_servizio,
            f_modalita_fiera: state => state.f_modalita_fiera,
            f_distretto: state => state.f_distretto,
            franchising: state => state.franchising
        }),
        ...mapState('order', {
            id_punto_di_servizio: state => state.id_punto_di_servizio
        }),
        ...mapGetters('restaurant', {
            getRestaurantServices: 'restaurantServices'
        }),
        ...mapGetters('order', {
            cartMustBeReset: 'cartMustBeReset'
        })
    },
    methods: {
        onRoomClick: function (locale) {
            if (locale && !locale.licenza.f_attivo) {
                this.showModalErrors({
                    title: this.$t('attenzione_label').toUpperCase(),
                    errors: [locale.licenza.testo]
                });

                return;
            }

            let service = null;
            let point = null;

            if (this.f_distretto || (this.f_modalita_fiera && this.punti_di_servizio && this.punti_di_servizio.length)) {
                if (this.getRestaurantServices().length > 1) {
                    this.$router.push({name: 'rooms.type', query: {canGoBack: '1'}}).catch(() => {
                        //
                    });
                } else if (this.getRestaurantServices().length) {
                    service = this.getRestaurantServices()[0];

                    if (service === 'DIL') {
                        if (this.punti_di_servizio.length > 1) {
                            this.$router.push({name: 'rooms.zone', query: {canGoBack: '1', service}}).catch(() => {
                                //
                            });
                        } else if (this.punti_di_servizio.length) {
                            point = this.punti_di_servizio[0];

                            const roomsIds = point.conf_ordini_prenotazioni_pds.map(
                                (conf) => conf.id_locale,
                            );

                            const rooms = this.locali.filter((room) => {
                                return roomsIds.includes(room.id);
                            });

                            if (this.franchising && rooms.length > 1) {
                                this.$router.push({
                                    name: 'rooms',
                                    query: {canGoBack: '1', service, pointId: point.id}
                                }).catch(() => {
                                    //
                                });
                            }
                        }
                    }
                }
            } else if (this.franchising && this.locali.length > 1) {
                if (this.cartMustBeReset(locale.id)) {
                    this.showModalCartReset({
                        show: true,
                        callback: (success) => {
                            if (success) {
                                this.onLocaleChange(locale);
                            }
                        }
                    });
                } else {
                    this.onLocaleChange(locale);
                }
            }
        },
        onLocaleChange: function (locale) {
            if (this.locale.id !== locale.id) {
                this.resetOrder();
            }
            this.setLocale(locale);

            this.$router.replace({name: 'home'}).catch(() => {
                //
            });
        },
        ...mapActions('order', {
            resetOrder: 'reset'
        }),
        ...mapActions('global', [
            'showModalCartReset',
            'showModalErrors'
        ]),
        ...mapActions('restaurant', [
            'setLocale'
        ]),
    }
}
</script>
